var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardPhoneNumberIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.028,
    height: 41,
    viewBox: "0 0 41.028 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone_Number_outline",
    "data-name": "Phone Number_outline",
    transform: "translate(0.514 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M38.467,16.557A17.384,17.384,0,0,0,30.9,11.189,29.613,29.613,0,0,0,9.13,11.157,17.377,17.377,0,0,0,1.543,16.5,6.862,6.862,0,0,0,.31,22.808a3.306,3.306,0,0,0,3.169,2.284l5,0H8.48a3.338,3.338,0,0,0,2.568-1.2,3.283,3.283,0,0,0,.715-2.7q-.008-.042-.018-.084l-.263-1.022A20.384,20.384,0,0,1,20,18.08a20.925,20.925,0,0,1,8.518,2.055l-.267,1.016q-.011.043-.019.087a3.284,3.284,0,0,0,.708,2.7,3.338,3.338,0,0,0,2.571,1.2l5,0h.005a3.305,3.305,0,0,0,3.169-2.275A6.869,6.869,0,0,0,38.467,16.557Z",
    transform: "translate(0 -9.1)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(4.174 15.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M80.554,195.993l-3.726-3.912a1.194,1.194,0,0,0-.864-.37H73.556v-1.627a1.194,1.194,0,0,0-2.387,0v1.627H67.347v-1.627a1.194,1.194,0,0,0-2.387,0v1.627H62.552a1.194,1.194,0,0,0-.864.37l-3.726,3.912a16.352,16.352,0,0,0-4.53,11.325v4.91a1.194,1.194,0,0,0,1.194,1.194H83.891a1.194,1.194,0,0,0,1.194-1.194v-4.91A16.352,16.352,0,0,0,80.554,195.993Zm-11.3,13.066a6.247,6.247,0,1,1,6.247-6.247A6.254,6.254,0,0,1,69.258,209.059Z",
    transform: "translate(-53.432 -188.89)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(16.141 25.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M210.463,317.691a3.86,3.86,0,1,0,3.86,3.86A3.864,3.864,0,0,0,210.463,317.691Z",
    transform: "translate(-206.603 -317.691)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPhoneNumberIcon);
export default __webpack_public_path__ + "static/media/dashboard-phone-number-icon.4230cfd196ce4f8873a3e882bc440e40.svg";
export { ForwardRef as ReactComponent };